<template>
    <v-card-text class="pa-3">
        <div class="text-center">
            <h4 class="title font-weight-bold primary--text mb-5">
                Account Verification
            </h4>
        </div>

        <v-form
            class="text-center"
            @submit.prevent="verify"
        >
            <v-text-field
                autofocus
                aria-required
                required
                name="tfa-code"
                v-validate="'required'"
                validate-on-blur
                :error-messages="errors.first('tfa-code')"
                type="text"
                label="Two Factor Authentication Code"
                append-icon="mdi-email-outline"
                background-color="#fcfcfc"
                v-model="verificationCode"
                outlined
                ref="tfa-code"
            >
            </v-text-field>

            <v-row no-gutters class="align-center" v-if="phoneNumberEndingIn">
                <v-col class="text-right">
                    <p class="caption">A verification code has been sent to you number ending in {{ phoneNumberEndingIn }}</p>
                </v-col>
            </v-row>

            <v-row no-gutters class="align-center">
                <v-col>
                    <v-btn
                        class="px-12 text--white"
                        color="primary"
                        block
                        text
                        depressed
                        x-large
                        @click.prevent="resendCode"
                    >
                         Resend code
                    </v-btn>
                </v-col>
                <v-col class="text-right">
                    <v-btn
                        class="px-12 text--white"
                        color="primary"
                        block
                        dark
                        depressed
                        x-large
                        @click.prevent="verify"
                    >
                        Continue
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <loading-overlay :loading="loading"></loading-overlay>
    </v-card-text>
</template>

<script>

export default {
    props: {
    },
    data() {
        return {
            loading: false,
            verificationCode: null,
            requestId: null,
            phoneNumberEndingIn: null,
            attempts: 0,
        };
    },
    mounted() {
        this.requestVerification();
    },
    methods: {
        async requestVerification() {
            try {
                this.loading = true;
                const { data } = await Vue.backendApi().worldremit()
                    .requestVerification();

                this.requestId = data.requestId;
                this.phoneNumberEndingIn = data.phoneNumberEndingIn;
                this.loading = false;
            } catch (err) {
                this.loading = false;
                this.$swal({
                    type: 'error',
                    title: 'Error requesting verification vode. Try to resend code',
                    text: err
                });
            }
        },
        async resendCode() {
            try {
                this.loading = true;
                const { data } = await Vue.backendApi().worldremit()
                    .requestVerification();

                this.requestId = data.requestId;
                this.phoneNumberEndingIn = data.phoneNumberEndingIn;
                this.loading = false;

                this.$swal({
                    type: 'success',
                    title: 'New code has been sent to your phone number',
                });
            } catch (err) {
                this.loading = false;
                this.$swal({
                    type: 'error',
                    title: 'Something wrong. Try again',
                    text: err
                });
            }
        },
        async verify() {
            if (!this.verificationCode || !this.requestId) {
                return;
            }

            try {
                this.loading = true;
                this.attempts++;
                const { data } = await Vue.backendApi().worldremit()
                    .verify({
                        verificationCode: this.verificationCode,
                        requestId: this.requestId,
                    });

                this.loading = false;
                this.$emit('success', data);
            } catch (err) {
                this.loading = false;
                if (this.attempts <= 3) {
                    this.$swal({
                        type: 'error',
                        title: 'Something wrong. Try again',
                        text: err,
                    });
                } else {
                    this.$emit('error', err);
                }

            }
        },
    },
}
</script>
